import {
  createContext, useContext, useMemo, useState,
} from 'react';

const WagonContext = createContext({
  direction: 'departure',
  floor: 1,
});

export const useWagonContext = () => useContext(WagonContext);

export function WagonContextProvider({ children, direction, floor }) {
  const [directionValue] = useState(direction);
  const contextValue = useMemo(() => ({
    direction: directionValue,
    floor,
  }), [directionValue, floor]);

  return (
    <WagonContext.Provider value={contextValue}>
      {children}
    </WagonContext.Provider>
  );
}
